var bogPayGoogleScript
export default {
  methods: {
    loadBogPayGoogleScript(success = () => { }) {
      // console.log(publicKey)
      if (!bogPayGoogleScript) {
        bogPayGoogleScript = window.document.createElement('script')
        bogPayGoogleScript.src = 'https://pay.google.com/gp/p/js/pay.js'
        bogPayGoogleScript.onload = () => {
          success && success()
        }
        var head = window.document.head || window.document.getElementsByTagName('head')[0] || window.document.documentElement
        head.insertBefore(bogPayGoogleScript, head.firstChild)
      } else {
        success && success()
      }
    }
  }
}
